import React from 'react';
import { styled } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { Colors } from 'library';

interface IconTitleProps {
    icon?: SvgIconComponent;
    children: React.ReactNode;
    size?: 'small' | 'medium';
    color?: string;
}

const SIZES = {
    small: { fontSize: 14, fontWeight: 600, iconSize: 18 },
    medium: { fontSize: 16, fontWeight: 700, iconSize: 20 },
};

export function IconTitle({ icon: Icon, children, size = 'medium', color }: IconTitleProps) {
    const { iconSize } = SIZES[size];
    const iconColor = color ?? Colors.textSecondary;

    return (
        <Row>
            {Icon && <Icon sx={{ fontSize: iconSize, color: iconColor }} />}
            <Title size={size} titleColor={color}>
                {children}
            </Title>
        </Row>
    );
}

const Row = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
});

const Title = styled('span')<{ size: 'small' | 'medium'; titleColor?: string }>(({ size, titleColor }) => ({
    fontSize: SIZES[size].fontSize,
    fontWeight: SIZES[size].fontWeight,
    color: titleColor ?? Colors.primary,
    margin: 0,
}));
